import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface OtherAmountProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OtherAmount: React.FC<OtherAmountProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [otherAmount, set_otherAmount] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => (b.values?.['Major Systems Rough-ins']?.['Other, Describe']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems Rough-ins': { ...b.values?.['Major Systems Rough-ins'], 'Other, Describe': [b.values?.['Major Systems Rough-ins']?.['Other, Describe']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Other - Amount';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(otherAmount)}
                />
            ) : (
                <MoneyBox
                    id={'otherAmount-majorSystemRoughIns'}
                    allowNegative={false}
                    value={otherAmount}
                    onChange={(value) => set_otherAmount(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
